(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { useMemo } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Link } from "react-router-dom";
import qs from "qs";
import styles from "./Logo.module.css";
import useQueryParams from "../../hooks/useQueryParams";

const Logo = _ref => {
  let {
    className,
    logoSrc,
    basicUrl
  } = _ref;
  const [{
    country
  }] = useQueryParams();
  const searchQuery = useMemo(() => qs.stringify({
    country
  }, {
    addQueryPrefix: true
  }), [country]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.logo, className)
  }, /*#__PURE__*/React.createElement(Link, {
    to: {
      pathname: basicUrl || "/",
      search: searchQuery
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: logoSrc,
    alt: "portming logo"
  })));
};

__signature__(Logo, "useQueryParams{[{ country }]}\nuseMemo{searchQuery}", () => [useQueryParams]);

Logo.propTypes = {
  className: PropTypes.string,
  basicUrl: PropTypes.string,
  logoSrc: PropTypes.string.isRequired
};
Logo.defaultProps = {
  className: null,
  basicUrl: ""
};

const _default = /*#__PURE__*/React.memo(Logo);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Logo, "Logo", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Logo/Logo.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Logo/Logo.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();